class ChangeClientError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ChangeClientError';
  }
}

export default ChangeClientError;
